import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import Section from '../components/Section';

export default () => (
  <Section id="engineering">
    <h1><FormattedHTMLMessage id="pages:engineering:title" /></h1>
    <FormattedHTMLMessage id="pages:engineering:description" />
  </Section>
);



// WEBPACK FOOTER //
// ./src/sections/Engineering.js